import { useEffect } from "react";
import { setUserClickData } from "../../utility/setUserClickData";

const redirectUser = (offer) => {
  // Store event in DB
  setUserClickData({
    event_name: `sms-ivr-campaign-for-${offer.lender_name}-old-lead`,
    user_id: offer.lead_id || "No User ID found",
    affiliate_id: offer.aff_id || "No Aff_id found",
    utm_source: offer.utm_source || "",
  });

  let redirectLink = "/"; // fallback

  if (offer.lender_name === "IndusInd") {
    redirectLink = `https://induseasycredit.indusind.com/customer/personal-loan/new-lead?utm_code=z_mktgcamp&utm_campaign=PL-Aff&utm_source=Digitmoney&utm_medium=display&utm_content=${offer.lead_id}`;
  } else if (offer.lender_name === "HeroFincorp") {
    redirectLink = `https://hipl.onelink.me/S7fO?af_xp=custom&pid=DigitMoney&c=DigitMoney_ACQ_07052025&is_retargeting=true&af_reengagement_window=30d&af_ios_url=https%3A%2F%2Floans.apps.herofincorp.com%2Fen%2Fpersonal-loan&af_android_url=https%3A%2F%2Floans.apps.herofincorp.com%2Fen%2Fpersonal-loan&utm_source=partnership&utm_campaign=DigitMoney&utm_content=${offer.lead_id}&utm_campaignid=${offer.aff_id}&utm_medium=SMS
`;
  } else if (offer.lender_name === "Kissht") {
    redirectLink = `https://app.appsflyer.com/com.fastbanking?pid=digitmoney_int&af_siteid=${offer.aff_id}&c=Digitmoney&af_sub1=${offer.lead_id}&is_retargeting=true&af_reengagement_window=7d&af_inactivity_window=30d&af_channel=${offer.utm_source}&af_click_lookback=7d&clickid=tid&af_prt=digitmoneytechn`;
  } else {
    console.warn("Lender link not found. Redirecting to homepage.");
  }

  window.location.href = redirectLink;
};

// Example usage in a component
const CampaignRedirect = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const offer = {
      lead_id: params.get("lead_id"),
      lender_name: params.get("lender_name"),
      utm_source: params.get("utm_source"),
      aff_id: params.get("aff_id"),
    };

    redirectUser(offer);
  }, []);

  return (
    <p className="text-green-700 bg-green-100 border border-green-300 rounded-lg px-4 py-2 text-center font-semibold shadow-md">
      Redirecting...
    </p>
  );
};

export default CampaignRedirect;
